import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkConsentStatus } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';
import ThemedSpinner from './ThemedSpinner';
//import ConsentError from './ConsentError';

const ConsentTransfer = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let intervalId;

    const pollConsentStatus = async () => {
      try {
        await dispatch(checkConsentStatus(props.consent_guid, props.institution));
      } catch (err) {
      }
    };
      intervalId = setInterval(pollConsentStatus, 7000);
    
      return () => clearInterval(intervalId);
     
  });

  useEffect(() => {
    if (props.redirect_url) {
      const timer = setTimeout(() => {
        const slug = props.institution.slug || props.institution.name || props.consent_guid;
        dispatch(postMessageSuccess("awaiting_consent", {slug: slug}));
        window.open(props.redirect_url, '_blank');
      }, 3000);
      return () => clearTimeout(timer);
    }
  });


  return (
    <div id="intro">
      <div className="consent-data-wrapper transfer-to-provider">
        <h2 className="form-group text-center">
          Transferring you to <strong>{props.institution.name}</strong>
        </h2>
        <ThemedSpinner theme={props.theme} />
        <div className="form-group text-center">
          <p>We are redirecting you to the {props.institution.name} where you will login securely before viewing and authorising this request.</p>
        </div>
      </div>
    </div>
  );
};

export default ConsentTransfer;